import React, { Component } from 'react'
import { GET_APP_SETTING_BY_NAME, SEARCH } from '../../requests'
import { connect } from 'react-redux'
import { clearSearchError, setSearchError, toggleSearching } from './SearchActions'
import isValid from 'date-fns/isValid'
import format from 'date-fns/format'
import PrintIcon from '@tecuity/sos-icons/react/print-solid'
import { Accordion } from '@tecuity/granite-ui'
import { Spinner } from '../Loaders/Loaders'
import AdvancedParameters from './AdvancedParameters'
import { parseUrlQuery } from '../../Utilities/Utilities'
import ReactMarkdown from 'react-markdown'
import rehypeRaw from 'rehype-raw'

export class SearchBox extends Component {
  getDefaultValues = (parameters) => {
    return parameters.reduce((obj, param) => ({ ...obj, [param.Name]: param.defaultValue }), {})
  }
  state = {
    processedThroughDateBusiness: '',
    processedThroughDateUCC: '',
    processedThroughDateCROP: '',
    processedThroughDateTrademark: '',
    searchExtraDescBusiness: null,
    searchExtraDescUCC: null,
    searchExtraDescCROP: null,
    searchExtraDescTrademark: null,
    drawerIsOpen: this.props.advancedParametersStartOpen ? true : false,
    hasValue: false,
    inputValue: '',
    advancedParameterValues: this.getDefaultValues(this.props.advancedParameters),
    accordionIsOpen: false,
    inactive: false,
    placeholder: this.props.placeholder,
    searchEntryRequired: true,
  }
  componentDidMount = () => {
    this.input.focus()
    this.getProcessedThroughDates(this.props.category)
    this.checkForStaleSearch(this.props)
  }
  componentDidUpdate = (prevState) => {
    this.checkForStaleSearch(this.props)
  }
  checkForStaleSearch = (props) => {
    if (props.isStale) {
      this.search()
    }
  }
  checkForSubmit = (e) => {
    if (e.charCode === 13) {
      this.search({ fromMainSearch: true })
    } else if (this.props.forceNumericalSearch) {
      if (e.charCode < 48 || e.charCode > 57) {
        e.preventDefault()
      }
    }
  }
  selectSearch = () => {
    this.input.select()
  }
  getProcessedThroughDates = (category) => {
    if (category == 'business') {
      GET_APP_SETTING_BY_NAME('BUSINESS_PROCESSED_THROUGH_DATE', (res) => {
        this.setState({
          ...this.state,
          processedThroughDateBusiness: res.VALUE,
        })
      })
      GET_APP_SETTING_BY_NAME('BUSINESS_SEARCH_EXTRA_DESCRIPTION', (res) => {
        this.setState({
          ...this.state,
          searchExtraDescBusiness: res.VALUE,
        })
      })
    } else if (category == 'ucc') {
      GET_APP_SETTING_BY_NAME('UCC_PROCESSED_THROUGH_DATE', (res) => {
        this.setState({
          ...this.state,
          processedThroughDateUCC: res.VALUE,
        })
      })
      GET_APP_SETTING_BY_NAME('UCC_SEARCH_EXTRA_DESCRIPTION', (res) => {
        this.setState({
          ...this.state,
          searchExtraDescUCC: res.VALUE,
        })
      })
    } else if (category == 'crop') {
      GET_APP_SETTING_BY_NAME('CROP_PROCESSED_THROUGH_DATE', (res) => {
        this.setState({
          ...this.state,
          processedThroughDateCROP: res.VALUE,
        })
      })
      GET_APP_SETTING_BY_NAME('CROP_SEARCH_EXTRA_DESCRIPTION', (res) => {
        this.setState({
          ...this.state,
          searchExtraDescCROP: res.VALUE,
        })
      })
    } else {
      GET_APP_SETTING_BY_NAME('TRADEMARK_PROCESSED_THROUGH_DATE', (res) => {
        this.setState({
          ...this.state,
          processedThroughDateTrademark: res.VALUE,
        })
      })
      GET_APP_SETTING_BY_NAME('TRADEMARK_SEARCH_EXTRA_DESCRIPTION', (res) => {
        this.setState({
          ...this.state,
          searchExtraDescTrademark: res.VALUE,
        })
      })
    }
  }
  setValue = (value) => {
    this.input.value = value || ''
    this.setState({ hasValue: value ? !!value.length : false })
  }
  search = ({ offset, print, fromMainSearch } = {}) => {
    if (!this.props.searching) {
      let parameters = {}
      if (this.parameters) {
        parameters = this.state.advancedParameterValues
      }
      parameters.OFFSET = offset
      parameters.PRINT = print
      parameters.FROM_MAIN_SEARCH = fromMainSearch
      this.props.search(this.input.value, parameters)
    }
  }
  trimValue = (e) => {
    if (e.target.value.length > (this.props.maxlength || 50)) {
      this.input.value = e.target.value.slice(0, this.props.maxlength || 50) || ''
    }
    this.setState({ hasValue: !!e.target.value.length, inputValue: e.target.value })
  }
  clearFilters = () => {
    this.setState({ advancedParameterValues: this.getDefaultValues(this.props.advancedParameters) })
  }
  setAdvanceParameterValues = (values) => this.setState({ advancedParameterValues: values })
  processedThruDatesValid = (category) => {
    let valid = true
    if (category == 'business') {
      if (
        !this.state.processedThroughDateBusiness ||
        this.state.processedThroughDateBusiness == ''
      ) {
        return false
      }
      if (this.state.processedThroughDateBusiness == 'SYSTEMDATE') {
        //do nothing
      } else {
        let parsed = new Date(this.state.processedThroughDateBusiness)
        valid = isValid(parsed)
      }
    } else if (category == 'ucc') {
      if (!this.state.processedThroughDateUCC || this.state.processedThroughDateUCC == '') {
        return false
      }
      if (this.state.processedThroughDateUCC == 'SYSTEMDATE') {
        //do nothing
      } else {
        valid = isValid(new Date(this.state.processedThroughDateUCC))
      }
    } else if (category == 'crop') {
      if (!this.state.processedThroughDateCROP || this.state.processedThroughDateCROP == '') {
        return false
      }
      if (this.state.processedThroughDateCROP == 'SYSTEMDATE') {
        //do nothing
      } else {
        valid = isValid(new Date(this.state.processedThroughDateCROP))
      }
    } else {
      if (
        !this.state.processedThroughDateTrademark ||
        this.state.processedThroughDateTrademark == ''
      ) {
        return false
      }
      if (this.state.processedThroughDateTrademark == 'SYSTEMDATE') {
        //do nothing
      } else {
        valid = isValid(new Date(this.state.processedThroughDateTrademark))
      }
    }
    return valid
  }
  accordionContent = (category) => {
    return category === 'business' ? (
      this.state.searchExtraDescBusiness ? (
        this.state.searchExtraDescBusiness.includes('{{BUSINESS_PROCESSED_THROUGH_DATE}}') &&
          this.processedThruDatesValid(category) ? (
          <span
            dangerouslySetInnerHTML={{
              __html: this.state.searchExtraDescBusiness.replace(
                '{{BUSINESS_PROCESSED_THROUGH_DATE}}',
                format(
                  new Date(
                    this.state.processedThroughDateBusiness == 'SYSTEMDATE'
                      ? Date.now()
                      : this.state.processedThroughDateBusiness
                  ),
                  'MMMM dd, yyyy'
                )
              ),
            }}
          ></span>
        ) : (
          <span dangerouslySetInnerHTML={{ __html: this.state.searchExtraDescBusiness }}></span>
        )
      ) : process.env.BUSINESS_SEARCH_EXTRA_DISCLAIMER ? (
        process.env.BUSINESS_SEARCH_EXTRA_DISCLAIMER.includes(
          '{{BUSINESS_PROCESSED_THROUGH_DATE}}'
        ) && this.processedThruDatesValid(category) ? (
          <span
            dangerouslySetInnerHTML={{
              __html: process.env.BUSINESS_SEARCH_EXTRA_DISCLAIMER.replace(
                '{{BUSINESS_PROCESSED_THROUGH_DATE}}',
                format(
                  new Date(
                    this.state.processedThroughDateBusiness == 'SYSTEMDATE'
                      ? Date.now()
                      : this.state.processedThroughDateBusiness
                  ),
                  'MMMM dd, yyyy'
                )
              ),
            }}
          ></span>
        ) : (
          <span
            dangerouslySetInnerHTML={{ __html: process.env.BUSINESS_SEARCH_EXTRA_DISCLAIMER }}
          ></span>
        )
      ) : (
        ''
      )
    ) : category === 'ucc' ? (
      this.state.searchExtraDescUCC ? (
        this.state.searchExtraDescUCC.includes('{{UCC_PROCESSED_THROUGH_DATE}}') &&
          this.processedThruDatesValid(category) ? (
          <span
            dangerouslySetInnerHTML={{
              __html: this.state.searchExtraDescUCC.replace(
                '{{UCC_PROCESSED_THROUGH_DATE}}',
                format(
                  new Date(
                    this.state.processedThroughDateUCC == 'SYSTEMDATE'
                      ? Date.now()
                      : this.state.processedThroughDateUCC
                  ),
                  'MMMM dd, yyyy'
                )
              ),
            }}
          ></span>
        ) : (
          <span dangerouslySetInnerHTML={{ __html: this.state.searchExtraDescUCC }}></span>
        )
      ) : process.env.UCC_SEARCH_EXTRA_DISCLAIMER ? (
        process.env.UCC_SEARCH_EXTRA_DISCLAIMER.includes('{{UCC_PROCESSED_THROUGH_DATE}}') &&
          this.processedThruDatesValid(category) ? (
          <span
            dangerouslySetInnerHTML={{
              __html: process.env.UCC_SEARCH_EXTRA_DISCLAIMER.replace(
                '{{UCC_PROCESSED_THROUGH_DATE}}',
                format(
                  new Date(
                    this.state.processedThroughDateUCC == 'SYSTEMDATE'
                      ? Date.now()
                      : this.state.processedThroughDateUCC
                  ),
                  'MMMM dd, yyyy'
                )
              ),
            }}
          ></span>
        ) : (
          <span
            dangerouslySetInnerHTML={{ __html: process.env.UCC_SEARCH_EXTRA_DISCLAIMER }}
          ></span>
        )
      ) : (
        ''
      )
    ) : category === 'crop' ? (
      this.state.searchExtraDescCROP ? (
        this.state.searchExtraDescCROP.includes('{{CROP_PROCESSED_THROUGH_DATE}}') &&
          this.processedThruDatesValid(category) ? (
          <span
            dangerouslySetInnerHTML={{
              __html: this.state.searchExtraDescCROP.replace(
                '{{CROP_PROCESSED_THROUGH_DATE}}',
                format(
                  new Date(
                    this.state.processedThroughDateCROP == 'SYSTEMDATE'
                      ? Date.now()
                      : this.state.processedThroughDateCROP
                  ),
                  'MMMM dd, yyyy'
                )
              ),
            }}
          ></span>
        ) : (
          <span dangerouslySetInnerHTML={{ __html: this.state.searchExtraDescCROP }}></span>
        )
      ) : process.env.CROP_SEARCH_EXTRA_DISCLAIMER ? (
        process.env.CROP_SEARCH_EXTRA_DISCLAIMER.includes('{{CROP_PROCESSED_THROUGH_DATE}}') &&
          this.processedThruDatesValid(category) ? (
          <span
            dangerouslySetInnerHTML={{
              __html: process.env.CROP_SEARCH_EXTRA_DISCLAIMER.replace(
                '{{CROP_PROCESSED_THROUGH_DATE}}',
                format(
                  new Date(
                    this.state.processedThroughDateCROP == 'SYSTEMDATE'
                      ? Date.now()
                      : this.state.processedThroughDateCROP
                  ),
                  'MMMM dd, yyyy'
                )
              ),
            }}
          ></span>
        ) : (
          <span
            dangerouslySetInnerHTML={{ __html: process.env.CROP_SEARCH_EXTRA_DISCLAIMER }}
          ></span>
        )
      ) : (
        ''
      )
    ) : category === 'trademark' ? (
      this.state.searchExtraDescTrademark ? (
        this.state.searchExtraDescTrademark.includes('{{TRADEMARK_PROCESSED_THROUGH_DATE}}') &&
          this.processedThruDatesValid(category) ? (
          <span
            dangerouslySetInnerHTML={{
              __html: this.state.searchExtraDescTrademark.replace(
                '{{TRADEMARK_PROCESSED_THROUGH_DATE}}',
                format(
                  new Date(
                    //this.state.processedThroughDateTrademark == 'SYSTEMDATE'?
                    Date.now()
                    // : this.state.processedThroughDateTrademark
                  ),
                  'MMMM dd, yyyy'
                )
              ),
            }}
          ></span>
        ) : (
          <span dangerouslySetInnerHTML={{ __html: this.state.searchExtraDescTrademark }}></span>
        )
      ) : process.env.TRADEMARK_SEARCH_EXTRA_DISCLAIMER ? (
        process.env.TRADEMARK_SEARCH_EXTRA_DISCLAIMER.includes(
          '{{TRADEMARK_PROCESSED_THROUGH_DATE}}'
        ) && this.processedThruDatesValid(category) ? (
          <span
            dangerouslySetInnerHTML={{
              __html: process.env.TRADEMARK_SEARCH_EXTRA_DISCLAIMER.replace(
                '{{TRADEMARK_PROCESSED_THROUGH_DATE}}',
                format(
                  new Date(
                    //this.state.processedThroughDateTrademark == 'SYSTEMDATE'?
                    Date.now()
                    // : this.state.processedThroughDateTrademark
                  ),
                  'MMMM dd, yyyy'
                )
              ),
            }}
          ></span>
        ) : (
          <span
            dangerouslySetInnerHTML={{ __html: process.env.TRADEMARK_SEARCH_EXTRA_DISCLAIMER }}
          ></span>
        )
      ) : (
        ''
      )
    ) : (
      ''
    )
  }
  render() {
    const {
      title = 'Search',
      placeholder,
      searching,
      category,
      advancedParameters,
      description,
      showSearchLiensCheckout,
      allowSearchPrint,
      hasResults,
      onPurchaseRequested,
      advancedParametersStartOpen,
      minimumSearchCharacters,
      searchRequirementsAreSatisfied,
      loggedIn,
      defaultValue,
    } = this.props

    const searchDisabled = searchRequirementsAreSatisfied
      ? !searchRequirementsAreSatisfied(this.state.inputValue, this.state.advancedParameterValues)
      : minimumSearchCharacters
        ? this.state.inputValue.trim().length < minimumSearchCharacters
        : false

    //nameSearch will contain either a boolean or the alternate place holder text. If true, means to disable/inactive the main
    //search text box and remove any text because the advanced options will have the required fields.
    const changeSearchBarToInactive = (nameSearch) => {      
      if (nameSearch === true) {
        this.input.value = ''
        this.setState({ inactive: true, placeholder: 'Please Use the Search Parameters Below', searchEntryRequired: !nameSearch })
      } else if (nameSearch){
        this.setState({ inactive: false, placeholder: nameSearch, searchEntryRequired: true })
      } else this.setState({ inactive: false, placeholder: this.props.placeholder, searchEntryRequired: !nameSearch })      
    }

    return (
      <div className="search-box">
        <h1>
          {title}
          {showSearchLiensCheckout && loggedIn && (
            <button
              className="btn btn-primary btn-raised align-right"
              onClick={() =>
                onPurchaseRequested(this.input.value, this.state.advancedParameterValues)
              }
              disabled={!hasResults}
            >
              Purchase Search
            </button>
          )}
          {allowSearchPrint ? (
            <button
              className="btn btn-primary btn-raised align-right print-button"
              onClick={() => this.search({ print: true })}
              disabled={!hasResults}
            >
              <PrintIcon /> Print
            </button>
          ) : null}
        </h1>
        {description && <ReactMarkdown children={description} className="markdown description" rehypePlugins={[rehypeRaw]} />}
        {process.env.SHOW_SEARCH_ACCORDIONS && this.accordionContent(category) && (
          <Accordion
            style={{ paddingBottom: '10px' }}
            isOpen={this.state.accordionIsOpen}
            title={`${category === 'ucc'
                ? category.toUpperCase()
                : category.charAt(0).toUpperCase() + category.slice(1)
              } Search Info:`}
            onChange={() => this.setState({ accordionIsOpen: !this.state.accordionIsOpen })}
          >
            {this.accordionContent(category) && (
              <div className="markdown description">{this.accordionContent(category)}</div>
            )}
          </Accordion>
        )}
        <div className="search-input-wrapper">
          <div className="inner-input-wrapper">
            <input
              ref={(ref) => {
                this.input = ref
              }}
              type="text"
              onKeyPress={this.checkForSubmit}
              onFocus={this.selectSearch}
              onChange={this.trimValue}
              placeholder={this.state.placeholder}
              className="search-input"
              disabled={searching || this.state.inactive}
              aria-label={placeholder}
              defaultValue={defaultValue ? defaultValue : ''}
              {...(!!minimumSearchCharacters &&
                this.state.searchEntryRequired && { required: true, 'aria-required': true })}
            />
            {!!minimumSearchCharacters && this.state.searchEntryRequired && (
              <span className="required">*</span>
            )}
          </div>
          {!searching ? (
            <React.Fragment>
              <button
                className={`search-button ${this.state.drawerIsOpen ? 'hide' : ''}`}
                onClick={this.search}
                aria-label="Execute search"
                aria-disabled={searchDisabled}
                aria-hidden={this.state.drawerIsOpen}
                tabIndex={this.state.drawerIsOpen ? -1 : undefined}
                aria-busy={searching}
                aria-invalid={searchDisabled}
                aria-describedby="search-disabled-hint"
                title={`Minimum of ${minimumSearchCharacters || 2
                  } Alpha-Numeric Characters Required`}
              >
                <span className="icon icon-zoom-medium" />
              </button>
              <p id="search-disabled-hint" aria-live="polite">
                {searchDisabled ? (
                  <span className=" visually-hidden">
                    {`Minimum of ${minimumSearchCharacters || 2} Alpha-Numeric Characters Required`}
                  </span>
                ) : null}
              </p>
            </React.Fragment>
          ) : (
            <Spinner
              tabIndex="0"
              id="search-spinner"
              aria-live="polite"
              aria-label="Searching"
              className="search-loader"
              themeColor="medium-neutral"
              linear
              size="medium"
            />
          )}
          {advancedParameters && (
            <AdvancedParameters
              key={category}
              ref={(ref) => {
                this.parameters = ref
              }}
              parameters={advancedParameters}
              values={this.state.advancedParameterValues}
              open={this.state.drawerIsOpen}
              onSearchRequested={this.search}
              onRequestToggleDrawer={(open, callback) => {
                this.setState(
                  (state) => ({ drawerIsOpen: open !== undefined ? open : !state.drawerIsOpen }),
                  () => {
                    if (!this.state.drawerIsOpen) {
                      this.input.focus()
                    }
                    if (callback) {
                      callback(this.state.drawerIsOpen)
                    }
                  }
                )
              }}
              clearFilters={this.clearFilters}
              onChange={this.setAdvanceParameterValues}
              startOpen={advancedParametersStartOpen}
              searchDisabled={searchDisabled}
              searching={searching}
              onNameSearch={changeSearchBarToInactive}
              minimumSearchCharacters={minimumSearchCharacters}
            />
          )}
        </div>
      </div>
    )
  }
}

export class ConnectedSearchBox extends Component {
  printWindow = null
  resultsCache = null
  componentDidMount = () => {
    if (!this.props.prefilledSearch) {
      var value = this.props.searchValueCache[this.props.category]
      this.setSearchValue(value ? value : '')
    }
  }
  componentDidUpdate = (prevProps) => {
    if (this.props.category !== prevProps.category) {
      this.setSearchValue(this.props.searchValueCache[this.props.category])
    }
  }
  setSearchValue = (value) => {
    this.searchBox.setValue(value)
  }
  componentWillUnmount = () => {
    delete window.onPrintPageReady
  }
  renderPrintPage = (results) => {
    window.onPrintPageReady = this.sendResultsToPrintPage
    this.resultsCache = results
    this.printWindow = window.open('/print-results', 'Print Results')
  }
  sendResultsToPrintPage = () => {
    this.printWindow.setPrintResults(this.resultsCache)
  }
  triggerSearch = (searchProps) => this.searchBox.search(searchProps)
  getSearchRequirementsFulfilled = (search, parameters) => {
    if (this.props.searchRequirementsAreSatisfied) {
      return this.props.searchRequirementsAreSatisfied(search, parameters)
    }
    const { searchMustHaveOneOf } = this.props
    const parametersConfig = this.props.advancedParameters.reduce((obj, param) => {
      obj[param.name] = param
      return obj
    }, {})
    if (searchMustHaveOneOf.includes('search')) {
      if (search !== '') {
        return true
      }
    }
    return searchMustHaveOneOf
      .filter((key) => key !== 'search')
      .some((key) => {
        const param = parameters[key]
        const config = parametersConfig[key]
        switch (config.type) {
          case 'dateRange':
            return param.start || param.end
          default:
            switch (typeof param) {
              case 'string':
                return param !== '' && param !== '0'
              case 'object':
                if (Array.isArray(param)) {
                  return param.length > 0
                }
                return true
              default:
                return true
            }
        }
      })
  }
  search = (value, parameters) => {
    const meetsMinimumSearchChars = this.props.minimumSearchCharacters
      ? value.trim().length >= this.props.minimumSearchCharacters
      : true

    const meetsSearchMustHaveOneOf =
      this.props.searchMustHaveOneOf !== undefined
        ? this.getSearchRequirementsFulfilled(value, parameters)
        : true

    const validSearch =
      value !== null && value !== undefined && meetsMinimumSearchChars && meetsSearchMustHaveOneOf

    if (
      this.props.searchRequirementsAreSatisfied
        ? this.props.searchRequirementsAreSatisfied(value, parameters)
        : validSearch
    ) {
      this.props.toggleSearching(true)
      if (parameters.FROM_MAIN_SEARCH) {
        setTimeout(() => {
          document.getElementById('search-spinner').focus()
        }, 100)
      }
      this.props.setSearchError(null)
      const sortingParameters =
        this.props.sortable && this.props.sortBy
          ? {
            SORT_BY_ID: this.props.sortBy,
            SORT_BY_DIRECTION: this.props.sortByDirection,
          }
          : {}
      const paginationParameters = this.props.isServerPaginated ? this.props.edge : {}
      SEARCH(
        { SEARCH_VALUE: value, ...parameters, ...paginationParameters, ...sortingParameters },
        this.props.category,
        (results) => {
          this.props.clearSearchError(this.props.category)
          this.props.toggleSearching(false)
          if (parameters.PRINT) {
            this.renderPrintPage(results)
          } else {
            this.props.onResultsReceived(results, value)
          }
        },
        (err = {}) => {
          console.error(err)
          this.props.setSearchError(
            {
              title: err.title,
              message: err.message ? err.message : typeof err === 'string' ? err : null,
            },
            this.props.category
          )
          this.props.toggleSearching(false)
        }
      )

      if (this.props.pushUpParameters) {
        this.props.pushUpParameters({ SEARCH_VALUE: value, ...parameters, ...sortingParameters })
      }
    }
  }
  render() {
    const { getSearchTrigger, advancedParametersStartOpen, isStale } = this.props
    if (getSearchTrigger) {
      getSearchTrigger(this.triggerSearch)
    }
    return (
      <SearchBox
        ref={(ref) => {
          this.searchBox = ref
        }}
        category={this.props.category}
        maxlength={
          this.props.appSettings['PublicSearchMaxLength']
            ? this.props.appSettings['PublicSearchMaxLength']
            : 50
        } // PublicSearchMaxLength
        title={this.props.title}
        placeholder={this.props.placeholder}
        search={this.search}
        searching={this.props.searching}
        advancedParameters={this.props.advancedParameters}
        description={this.props.description}
        showSearchLiensCheckout={this.props.showSearchLiensCheckout}
        allowSearchPrint={this.props.allowSearchPrint}
        hasResults={this.props.hasResults}
        onPurchaseRequested={this.props.onPurchaseRequested}
        loggedIn={this.props.loggedIn}
        advancedParametersStartOpen={advancedParametersStartOpen}
        searchRequirementsAreSatisfied={this.props.searchRequirementsAreSatisfied}
        minimumSearchCharacters={this.props.minimumSearchCharacters}
        isStale={isStale}
        defaultValue={this.props.prefilledSearch}
        forceNumericalSearch={this.props.forceNumericalSearch}
        key={this.props.category}
      />
    )
  }
}
ConnectedSearchBox = connect(
  (state) => ({
    searching: state.search.searching,
    searchValueCache: state.search.searchValueCache,
    loggedIn: state.auth.loggedIn,
    location: state.router.location,
    prefilledSearch: parseUrlQuery(state.router.location.search).prefill,
    appSettings: state.app.appSettings,
  }),
  { toggleSearching, setSearchError, clearSearchError }
)(ConnectedSearchBox)
